import { get } from "lodash-es";
import { TeamTab } from "./useTable";
import type {
  Maybe,
  TeamGameLog,
  GetHeadToHeadTeamStatsTabQuery,
} from "@/graphql/gql/graphql";

const dataToTableData = (gameLog: Maybe<Maybe<TeamGameLog>>[]) =>
  gameLog.map((game) => ({
    team: {
      homeTeam: get(game, "homeTeam"),
      opponentTeam: {
        abbreviation: get(game, "opponentTeam.abbreviation", "-"),
        logoSVG: get(game, "opponentTeam.logoSVG", ""),
      },
    },
    timestamp: get(game, "timestamp", 0),
    score: get(game, "score", "-"),
    week: get(game, "week", 0),
    passingYards: get(game, "passingYards", 0),
    passingTDs: get(game, "passingTDs", 0),
    opponentPassingRank: get(game, "opponentPassingRank", 0),
    rushingYards: get(game, "rushingYards", 0),
    rushingTDs: get(game, "rushingTDs", 0),
    opponentRushingRank: get(game, "opponentRushingRank", 0),
    passYardsAllowed: get(game, "passYardsAllowed", 0),
    opponentPassDefRank: get(game, "opponentPassDefRank", 0),
    rushYardsAllowed: get(game, "rushYardsAllowed", 0),
    opponentRushDefRank: get(game, "opponentRushDefRank", 0),
  }));

export const createTableData = (
  data?: GetHeadToHeadTeamStatsTabQuery["event"]
) => {
  const homeGameLog = data?.homeTeam?.gameLog ?? [];
  const awayGameLog = data?.awayTeam?.gameLog ?? [];

  return {
    [TeamTab.Home]: dataToTableData(homeGameLog),
    [TeamTab.Away]: dataToTableData(awayGameLog),
  };
};
